import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { DeliveryAddressService } from '@checkout/feature';
import { ModalService } from '@spartacus/storefront';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sd-delivery-address-dialog-modal',
  templateUrl: './delivery-address-dialog-modal.component.html',
  styleUrls: ['./delivery-address-dialog-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorDeliveryAddressDialogModalComponent implements OnInit, OnDestroy {
  subscription = new Subscription();

  constructor(
    private modalService: ModalService,
    private deliveryAddressService: DeliveryAddressService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.deliveryAddressService.savedAddressEvent.subscribe(() => this.modalService.closeActiveModal()),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
